export class LogradouroCep {
    Id: string; // No modelo o campo é "IDLogradouroCEP", utilizando "Id" por limitação do Mock-up
    IdLogradouro: string;
    CEP: string;
}



// WEBPACK FOOTER //
// ./src/app/logradouro-cep/logradouro-cep.model.ts